import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Paper, Button, Box, CircularProgress, Skeleton } from '@mui/material';
import AddCardIcon from '@mui/icons-material/AddCard';

import PaymentMethod from './PaymentMethod';
import {
  fetchPaymentMethods,
  removePaymentMethod,
  setPrimaryPaymentMethod,
  clearPaymentMethods,
} from '../../../actions/paymentMethods';

const PaymentMethodList = ({ primary }) => {
  const dispatch = useDispatch();
  const paymentMethods = useSelector((state) => state.paymentMethods);
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    dispatch(fetchPaymentMethods());
    return () => {
      dispatch(clearPaymentMethods());
    };
  }, [dispatch]);

  const handleSetPrimary = async (id) => {
    setEditing(true);
    await dispatch(setPrimaryPaymentMethod(id));
    setEditing(false);
  };

  const handleRemove = async (id) => {
    setEditing(true);
    await dispatch(removePaymentMethod(id));
    setEditing(false);
  };

  const renderPaymentMethods = () => {
    if (!paymentMethods) {
      return (
        <Paper sx={{ p: 2, position: 'relative' }}>
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'rgba(255, 255, 255, 0.7)',
            }}
          >
            <CircularProgress />
          </Box>
          {[1, 2, 3, 4].map((i) => (
            <Skeleton
              key={i}
              variant='rectangular'
              height={100}
              sx={{ mb: 2 }}
            />
          ))}
        </Paper>
      );
    }

    return paymentMethods.map((paymentMethod) => (
      <PaymentMethod
        key={paymentMethod.id}
        paymentMethod={paymentMethod}
        removePaymentMethod={() => handleRemove(paymentMethod.id)}
        isPrimary={primary === paymentMethod.id}
        setPrimary={() => handleSetPrimary(paymentMethod.id)}
        editing={editing}
      />
    ));
  };

  return (
    <Box sx={{ position: 'relative' }}>
      {editing && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'rgba(255, 255, 255, 0.7)',
            zIndex: 1,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {renderPaymentMethods()}
      <Box sx={{ mt: 2 }}>
        <Button
          component={Link}
          to='/account/billing/method/new'
          variant='contained'
          color='brand'
          disabled={editing}
          startIcon={<AddCardIcon />}
        >
          Add
        </Button>
      </Box>
    </Box>
  );
};

export default PaymentMethodList;
